module.exports = __webpack_public_path__ + "static/media/Roboto-Italic.55a26b3c.otf";